import { createStandardAction } from 'typesafe-actions'
import { AnyAction } from 'redux'
import { ThunkAction, ThunkDispatch } from 'redux-thunk'

import { axiosWithAdal } from '../../utils/http'
import { apiRoute } from '../../utils/routeUtils'
import { ISubscription } from '../../types/subscription'
import { HOSPITAL_SUBSCRIPTIONS_URL } from '../../constants/urls/backend'
import { localeMoment } from '../../utils/localeMoment'

const subscriptionsSuccess = createStandardAction('@@subscriptions/SUCCESS')<{ [id: number]: ISubscription[] }>()
const subscriptionsError = createStandardAction('@@subscriptions/ERROR')<string[]>()
const subscriptionsRequest = createStandardAction('@@subscriptions/REQUEST')()

interface IResponse {
  end: string
  start: string
  created: string
  updated: string
  id: number
  plan: number
}

const fetchSubscriptions = (hospitalId: string): ThunkAction<Promise<void>, {}, {}, AnyAction> => {
  return async (dispatch: ThunkDispatch<{}, {}, AnyAction>): Promise<void> => {
    dispatch(subscriptionsRequest())
    try {
      const hospitalSubsRoute = HOSPITAL_SUBSCRIPTIONS_URL(hospitalId)

      const response = await axiosWithAdal.get<IResponse[]>(apiRoute(hospitalSubsRoute), {
        headers: {
          'Content-Type': 'application/json',
        }
      })

      const subscriptions: ISubscription[] = response.data.map(x => ({
        id: x.id,
        planId: x.plan,
        start: localeMoment(x.start),
        end: localeMoment(x.end),
        created: localeMoment(x.created),
        updated: localeMoment(x.updated)
      }))

      const payload = {
        [hospitalId]: subscriptions
      }

      dispatch(subscriptionsSuccess(payload))
    } catch (e) {
      dispatch(subscriptionsError([ e.message ]))
      return
    }
  }
}

export {
  fetchSubscriptions,
  subscriptionsError,
  subscriptionsRequest,
  subscriptionsSuccess
}
